export const MINIMUM_POLYGON_POINTS = 4;
